// extracted by mini-css-extract-plugin
export default {"formItemFlex":"modbusPoint_formItemFlex__W-fok"};